<template>
    <div id="Container_ScheduleBlockingTimesList">
       <GroupAppointmentList>

       </GroupAppointmentList>
    </div>
</template>

<script>

export default {
    name: 'ScheduleGroupAppointmentList',

    data() {
        return {
        };
    },

    methods: {

    },

    created() {
    },

    mounted() {

    }
};
</script>
